import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import SlideshowItemIcon from '../SlideshowItemIcon';
import type { SlideshowItemContentProps } from '../types';

const SlideshowGen3TechSpecsContent = ({
  content,
  showDiscount,
}: Partial<SlideshowItemContentProps>) => {
  const t = useTranslations();
  if (!Array.isArray(content)) return <></>;

  return (
    <div
      className={cx('absolute left-6 lg:top-32 lg:left-28', {
        'top-24 md:top-28': showDiscount,
        'top-16': !showDiscount,
      })}
    >
      {content.map((contentProps) => {
        if (!contentProps) return null;

        const { copy, heading, iconName } = contentProps;
        return (
          <div
            className="mb-3 flex items-center gap-2 lg:mb-6 lg:gap-4"
            key={iconName}
          >
            <SlideshowItemIcon
              className="size-6 lg:size-12"
              iconName={iconName}
            />
            <div>
              <Typography className="text-sm lg:text-base">
                {t(heading!)}
              </Typography>
              <Typography className="hidden lg:block lg:text-sm" color="dark">
                {t(copy!)}
              </Typography>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SlideshowGen3TechSpecsContent;
